// extracted by mini-css-extract-plugin
module.exports = {"container":"_2T-qBGGM60hK7J07WdC-zW","icon":"_1Hi4VsJcAO3ulck3VYE0yo"};